var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg144Layout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94,0H70C31.402,0,0,31.402,0,70v372c0,38.598,31.402,70,70,70h24c38.598,0,70-31.402,70-70V70 C164,31.402,132.598,0,94,0z M124,442c0,16.542-13.458,30-30,30H70c-16.542,0-30-13.458-30-30V70c0-16.542,13.458-30,30-30h24 c16.542,0,30,13.458,30,30V442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,0H276c-38.598,0-70,31.402-70,70v24c0,38.598,31.402,70,70,70h166c38.598,0,70-31.402,70-70V70 C512,31.402,480.598,0,442,0z M472,94c0,16.542-13.458,30-30,30H276c-16.542,0-30-13.458-30-30V70c0-16.542,13.458-30,30-30h166 c16.542,0,30,13.458,30,30V94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,207H276c-38.598,0-70,31.402-70,70v165c0,38.598,31.402,70,70,70h166c38.598,0,70-31.402,70-70 c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,16.542-13.458,30-30,30H276c-16.542,0-30-13.458-30-30V277 c0-16.542,13.458-30,30-30h166c16.542,0,30,13.458,30,30v65c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-65 C512,238.402,480.598,207,442,207z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg144Layout);
export default __webpack_public_path__ + "static/media/144-layout.c6acc4ee74cb117a3d32cd4a19ec47fe.svg";
export { ForwardRef as ReactComponent };